/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */
/* Function for finding future date from the current date */

function addDays(days) {
  const currentDate = new Date();

  const fourDaysLater = new Date(currentDate.getTime() + (days * 24 * 60 * 60 * 1000));

  const day = String(fourDaysLater.getDate()).padStart(2, '0');
  const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const month = monthNames[fourDaysLater.getMonth()]; // Get the month name
  const year = fourDaysLater.getFullYear();

  return `${day} ${month} ${year}`;
}
/* End of Function for finding future date from the current date */

(function() {
    // Keep your scripts inside this IIFE function call to avoid leaking your
    // variables into the global scope.
    document.addEventListener("DOMContentLoaded", () => {
        let collectionHeroImages = document.querySelectorAll(".section--image.fade-in-child");
        if (document.title == "Three Seater Sofa Beds | Large Sofa Beds | Cocoon") {
            collectionHeroImages[0].style.display = "none";
            collectionHeroImages[2].style.display = "none";
            collectionHeroImages[3].style.display = "none";
            collectionHeroImages[4].style.display = "none";
        } else if (document.title == "Two Seater Sofa Beds | Double & Small Sofa Beds | Cocoon") {
            collectionHeroImages[1].style.display = "none";
            collectionHeroImages[2].style.display = "none";
            collectionHeroImages[3].style.display = "none";
            if (collectionHeroImages[4]) {
                collectionHeroImages[4].style.display = "none";
            }
        } else if (document.title == "Chair Beds | Chair & Single Sofa Beds | Cocoon") {
            collectionHeroImages[0].style.display = "none";
            collectionHeroImages[1].style.display = "none";
            collectionHeroImages[3].style.display = "none";
            if (collectionHeroImages[4]) {
                collectionHeroImages[4].style.display = "none";
            }
        } else if (document.title == "Storage Sofa Beds (4&5 Seater Sofa Beds) by Cocoon") {
            collectionHeroImages[0].style.display = "none";
            collectionHeroImages[1].style.display = "none";
            collectionHeroImages[2].style.display = "none";
            if (collectionHeroImages[4]) {
                collectionHeroImages[4].style.display = "none";
            }
        } else if (document.title == "Sofabed sheets and footstools – Cocoon") {
            collectionHeroImages[0].style.display = "none";
            collectionHeroImages[1].style.display = "none";
            collectionHeroImages[2].style.display = "none";
            collectionHeroImages[3].style.display = "none";
            if (collectionHeroImages[4]) {
                collectionHeroImages[4].style.display = "none";
            }
        } else if (document.title == "Clearance – Cocoon") {
            collectionHeroImages[0].style.display = "none";
            collectionHeroImages[1].style.display = "none";
            collectionHeroImages[2].style.display = "none";
            collectionHeroImages[3].style.display = "none";
            if (collectionHeroImages[4]) {
                collectionHeroImages[4].style.display = "none";
            }
        } else if (document.title == "Clearance Sofa Beds – Cocoon") {
            collectionHeroImages[0].style.display = "none";
            collectionHeroImages[1].style.display = "none";
            collectionHeroImages[2].style.display = "none";
            collectionHeroImages[3].style.display = "none";
        } else if (document.title == "Clearance Footstools – Cocoon") {
            collectionHeroImages[0].style.display = "none";
            collectionHeroImages[1].style.display = "none";
            collectionHeroImages[2].style.display = "none";
            collectionHeroImages[3].style.display = "none";
        }

        // --- Hide Clearance Footstools item from Collection Grid --- //
        if (document.title == "Collections – Cocoon") {
            let collectionGridItem = document.querySelectorAll(".grid__item.one-half");
            collectionGridItem[5].style.display = "none";
        }

    });


    // script.js
    // Manually update this variable with the new number whenever needed
    var deliverySlotNumber = 4; // Change this number as needed

    // This function will run on page load and update the <i> tag within the specified container
    function updateDeliverySlots() {
        // Select the <i> tag within the specified container
        var countdownElement = document.querySelector('.black-friday-message #left i');
        // Update the text content of the <i> tag with the new delivery slot number
        if (countdownElement) {
            countdownElement.textContent = deliverySlotNumber;
        }
    }

    // Event listener for DOM content load to update the slots on page load
    document.addEventListener('DOMContentLoaded', updateDeliverySlots);

    setTimeout(() => {
        const box = document.getElementById('box');
        // 👇️ removes element from DOM
        if (box) {
            box.style.display = 'none';
        }
    }, 1000);

    // ----- Product page category select ----- //
    let catSelects = document.querySelectorAll(".form__cat-select");
    let swatches = document.querySelectorAll(".swatch__button");
    let productForm = document.querySelector(".product__form__outer");
  /* show the delivery date as per setting values */
  const body = document.body; 
  if (body.classList.contains('template-product')) {
    let dlvyDays =document.querySelector('.dly_date_setting');
    dlvyDays = dlvyDays ? dlvyDays.value : '';
    if(dlvyDays){
      dlvyDays = parseInt(dlvyDays)
      const deliveryDateElement = document.getElementById('delivery_date');
      deliveryDateElement.innerHTML = addDays(dlvyDays);
    }
  }
  /* End of show the delivery date as per setting values */
  
  /* show/hide if more than 8 swatches*/
  const selectedSwatches = document.querySelectorAll('.swatch__button.selected');
  const selectedSwatchesCount = selectedSwatches.length;
  const moreClrElements = document.querySelectorAll('.more_clr');
              if(selectedSwatchesCount > 8 && document.querySelector('body').getAttribute('data-template') == 'product'){
                selectedSwatches.forEach((swatch, index) => {
                if (index > 7) {
                  swatch.style.display = 'none'; 
                }
              });
                moreClrElements.forEach(element => {
                  element.style.display = 'inline-block'; 
                });
              }
              else{
               moreClrElements.forEach(element => {
                  element.style.display = 'none'; 
                });
              }
    if (catSelects.length > 0) {
        catSelects.forEach((cat) => {
            cat.addEventListener("click", function(e) {
                let firstOptionSelected = false;
                productForm.classList.remove("cat-selected");
                let selectedSwatches_btn = document.querySelectorAll('.swatch__button.selected');
                let selectedSwatchesCount_btn = selectedSwatches_btn.length;
                $('.more_clr').show();
                swatches.forEach((swatch) => {
                    swatch.removeAttribute('style'); 
                    swatch.classList.remove("selected");
                    if (swatch.dataset.cat === e.target.value) {
                        if (!firstOptionSelected) {
                            swatch.querySelector("label").click();
                            firstOptionSelected = true;
                        }
                        productForm.classList.add("cat-selected");
                        swatch.classList.add("selected");
                    }
                });
                var swatches_len = $('[data-cat="'+e.target.value+'"]').length
                if(swatches_len > 7 && document.querySelector('body').getAttribute('data-template') == 'product'){
                  $('[data-cat="'+e.target.value+'"]:gt(7)').hide();
                }else{
                  $('.more_clr').hide();
                }
               $('.more_clr').html('More colours')
            });
        });
    }
  
  //Expand the hidden swatches when clicking on more colours:
 const moreClrButtons = document.querySelectorAll('.more_clr');
 moreClrButtons.forEach(button => {
  button.addEventListener('click', (event) => {
    const currentText = event.target.textContent; // Get current button text

    if (currentText === 'More colours') {
      button.textContent = 'Less colours'; // Update button text to 'Less colours'
      const selectedSwatches = document.querySelectorAll('.swatch__button.selected');
      selectedSwatches.forEach((swatch, index) => {
        
        if (index > 7) {
          swatch.style.display = 'inline-block'; 
        }
      });
    } else {
      button.textContent = 'More colours'; // Update button text to 'More colours'
      const selectedSwatches = document.querySelectorAll('.swatch__button.selected');
      selectedSwatches.forEach((swatch, index) => {
        if (index > 7) {
          swatch.style.display = 'none'; 
        }
      });
    }
  });
});
  /* Open dimensions when clicking on does fit pdp */
  const pdpFit = document.querySelectorAll('.pdp_does_btn, .does_fit__btn');
  pdpFit.forEach(fit =>{
    fit.addEventListener('click',(evt)=>{
     const tabHeaders = document.querySelectorAll('.tab-header');
      const tabpanel = document.querySelectorAll('.tab-pane')
    tabHeaders.forEach(header => {
      header.classList.remove('active');
    });
    tabpanel.forEach(panel => {
      panel.classList.remove('active');
    });
    const activeTab = document.querySelector('.tab-header[data-tab="0"]');
      const activepanel = document.querySelector('.tab-pane[data-tab-content="0"]'); 
    if (activeTab) {
      activeTab.classList.add('active');
    }
       if (activepanel) {
      activepanel.classList.add('active');
    }
        })
  })
  /* End of Open dimensions when clicking on does fit pdp */
  
    let addToCartBtns = document.querySelectorAll(
        ".shopify-payment-button__button, .add_to_cart_button, .btn--add-to-cart"
    );

    for (let i = 0; i < addToCartBtns.length; i++) {
        addToCartBtns[i].addEventListener("click", function() {
            gtag("event", "conversion", {
                send_to: "AW-720731173/Lpb1CJuxnqEDEKX41dcC",
            });
        });
    }

    //Replace image for Product Dimensions inside Accordian for Ashley
    let dimImage = document.getElementsByClassName("product-accordion-image");
    let zoomDimImage = document.getElementsByClassName(
        "product-accordion-zoomed-in"
    );
    let pageProductTitle = document.querySelector("h1.product__title");
    if (pageProductTitle !== null) {
        pageProductTitle = document.querySelector("h1.product__title").textContent;
        if (pageProductTitle.includes("Ashley Corner")) {
            dimImage.length > 0 ? dimImage[0].setAttribute(
                "src",
                "https://cdn.shopify.com/s/files/1/0073/6546/0004/files/Ashley-180-dimention.jpg?v=1680252602"
            ):'';
            zoomDimImage.length > 0 ? zoomDimImage[0].setAttribute(
                "src",
                "https://cdn.shopify.com/s/files/1/0073/6546/0004/files/Ashley-180-dimention.jpg?v=1680252602"
            ):'';
        }
    }

    //Lazyload to improve SEO & Site Performace
    let imgList = document.getElementsByTagName("img");
    for (let i = 0; i < imgList.length; i++) {
        imgList[i].classList.add("lazyload");
    }

    // --- Script that adds the offer+bed size tag images based on product type --- //
    let productPageTitle = document.querySelector("h1.product__title");
    if (productPageTitle !== null) {
        productPageTitle = document.querySelector("h1.product__title").textContent;
        // Find the target img element with the class ".product__media img"
        let mainSofaImage = document.querySelectorAll(".product__media img");

        if (productPageTitle.includes("Corner")) {
            // Create a new img element and assign the class ".offer-tag" to it
            const newImg = document.createElement("img");
            newImg.classList.add("offer-tag");

            // Insert the new img element right after the target img element
            mainSofaImage[0].insertAdjacentElement("afterend", newImg);
            newImg.src =
                "https://cdn.shopify.com/s/files/1/0073/6546/0004/files/icon-02.png?v=1683468642";
        }

        if (productPageTitle.includes("Three-Seater")) {
            // Create a new img element and assign the class ".offer-tag" to it
            const newImg = document.createElement("img");
            newImg.classList.add("offer-tag");

            // Insert the new img element right after the target img element
            mainSofaImage[0].insertAdjacentElement("afterend", newImg);
            newImg.src =
                "https://cdn.shopify.com/s/files/1/0073/6546/0004/files/icon-01.png?v=1683468642";
        }

        if (
            productPageTitle.includes("Two-Seater") ||
            productPageTitle.includes("Settee")
        ) {
            // Create a new img element and assign the class ".offer-tag" to it
            const newImg = document.createElement("img");
            newImg.classList.add("offer-tag");

            // Insert the new img element right after the target img element
            mainSofaImage[0].insertAdjacentElement("afterend", newImg);
            newImg.src =
                "https://cdn.shopify.com/s/files/1/0073/6546/0004/files/icon-03.png?v=1683468642";
        }
    }

    // --- End script that adds the offer+bed size tag images based on product type --- //
    // --- Script to remove Delivery Information Accordian from Clearance Products --- //
    let pageTitle = document.querySelector("h1.product__title");
    if (pageTitle !== null) {
        var clearanceTitle = pageTitle.textContent;
        if (
            clearanceTitle.includes("Good To Go") === true ||
            clearanceTitle.includes("Odd Bump") === true
        ) {
            var deliveryAccordian =
                document.getElementsByClassName("accordion__wrapper");
            deliveryAccordian[1].style.display = "none";

            var yotpoReview = document.getElementsByClassName("yotpo");
            yotpoReview[0].style.display = "none";

            var countdownTimer = document.querySelector(".countdown-timer");
            countdownTimer.style.cssText = "display:none !important";
        }
    }


    // --- PDP: restore the variant image in the gallery on initial page load --- //
    // Pipeline's <product-form> custom element dispatches 'theme:image:change'
    // from its constructor, which runs when theme.dev.js calls
    // customElements.define(). The gallery only attaches its listener later, on
    // DOMContentLoaded, so that first event is discarded and a direct
    // ?variant= URL keeps showing product.media[1]. Re-send it here: custom.js
    // is deferred after theme.dev.js, so this handler runs once the gallery is up.
    //
    // Deliberately gated on ?variant= being present, so product URLs without it
    // keep their existing lifestyle hero image.
    document.addEventListener("DOMContentLoaded", function() {
        var slideshow = document.querySelector("[data-product-slideshow]");
        if (!slideshow) return;

        // Keep the highlighted thumbnail in step with the gallery. The theme only
        // moves the 'is-activated' class when the thumb strip is NOT in its
        // Flickity mode; in Flickity mode it calls flktyThumbs.select() with the
        // slideshow index, which is off by one because the slideshow renders an
        // extra leading slide (product.media[1]) that the thumb strip does not.
        var thumbWrapper = document.querySelector("[data-product-thumbs]");
        if (thumbWrapper) {
            slideshow.addEventListener("theme:image:change", function(event) {
                var target = thumbWrapper.querySelector(
                    '[data-media-select="' + event.detail.id + '"]'
                );
                if (!target) return;
                var current = thumbWrapper.querySelector(".is-activated");
                if (current === target) return;
                if (current) current.classList.remove("is-activated");
                target.classList.add("is-activated");
            });
        }

        var params = new URLSearchParams(window.location.search);
        var variantId = params.get("variant");
        if (!variantId) return;

        var jsonEl = document.querySelector("[data-product-json]");
        if (!jsonEl) return;

        var product;
        try {
            product = JSON.parse(jsonEl.innerHTML);
        } catch (e) {
            return;
        }
        if (!product || !product.variants) return;

        var variant = product.variants.filter(function(v) {
            return String(v.id) === variantId;
        })[0];
        var mediaId = variant && variant.featured_media && variant.featured_media.id;
        if (!mediaId) return;

        var slide = slideshow.querySelector('[data-media-id="' + mediaId + '"]');
        if (!slide || slide.classList.contains("is-selected")) return;

        slideshow.dispatchEvent(new CustomEvent("theme:image:change", {
            detail: { id: mediaId }
        }));
    });
    // --- End PDP variant image on initial load --- //

})();